// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/pdfReportTopbanner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-container {}

.top-container {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    height: 100%;
    width: 100%;
    padding: 1rem;
    /* 16px padding on all sides */
}

.progress-report {
    font-size: 23.672px;
    color: white;
    margin: 0px;
    font-weight: 700;
    margin-top: 4px;
}

.formatted-date {
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    margin-top: 0px;
    font-weight: 600px;
    margin-top: 4px;
}

.overallimpact-section {
    margin-left: 15px;
    /* Equivalent to inline style */
    margin-top: 24px;
    /* Equivalent to mt-6 */
    display: flex;
    /* Equivalent to flex */
    gap: 8px;
    /* Equivalent to gap-[8px] */
    color: #263238;
}

.overallimpact-section h3 {
    font-size: 14px;
    /* Equivalent to text-sm */
    font-weight: 600;
    /* Equivalent to font-semibold */
    color: #263238;
    margin: 0px;
    margin-top: 6px;
}

.bg-img-container {
    position: relative;
    background-size: cover;
    background-position: center;
    height: 283px;
    width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
}

.hz-line {
    height: 6px;
    background: linear-gradient(90deg, #6DDA6C 14.2%, rgba(109, 218, 108, 0.00) 100%);
}

.overall-impact-content {
    background-color: #F6F5F5;
    margin-left: 15px;
    margin-right: 15px;
    border-radius: 6px;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
}

.overall-impact-column {
    display: flex;
    flex-direction: column;
    width: 50%;
}

.overall-impact-row {
    display: flex;
    align-items: start;
    margin-bottom: 12px;
}

.overall-impact-row-1 {
    display: flex;
    flex-direction: column;
    margin-right: 12px;
}

.percentage-text {
    color: #FF835B;
    font-size: 24px;
    font-weight: 900;
    line-height: 140%;
    width: 85px;
    text-align: right;
    margin-top: 30px;
    font-style: normal;
}

.vertical-divider {
    border: 0.5px solid black;
    height: 100px;
    margin-left: 10px;
    margin-right: 10px;
}

.impact-description {
    width: 245px;
    display: flex;
    flex-direction: column;
}

.impact-text {
    color: #667480;
    font-size: 12px;
    font-style: normal;
    line-height: normal;
    margin-top: 12px;
}

.bold-text {
    font-weight: bold;
    margin: 0 4px;
    color: black;
}

.small-text {
    font-weight: bold;
    margin: 0 2px;
    font-size: 8px;
}

.big-vertical-divider {
    margin-left: 30px;
    margin-right: 10px;
    height: 185px;
    border: 1px solid #D1D5DB;
}

.standing-svg {
    width: 46px;
    height: 86px;
    margin-bottom: 12px;
}

.total-exercise-count {
    color: #222B45;
    /* font-family: "Sans-serif", */
    font-size: 24px;
    font-style: normal;
    font-weight: bold;
    line-height: 140%;
    text-align: center
}

.pain-improvement-section {
    margin-left: 15px;
    margin-top: 18px;
    display: flex;
    justify-content: start;
    gap: 8px;
}

.pain-improvement-text {
    font-size: 14px;
    font-weight: 600;
    color: #263238;
    margin: 0px;
    margin-top: 6px;
}

.pain-improvement-container {
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 12px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
}

.pain-improvement-card {
    height: 60mm;
    max-width: 70mm;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #e5e7eb;
    padding: 9px;
    border-radius: 6px;
    height: 195px;
}

.circular-indicator-container {
    height: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pain-improvement-text-con {
    height: 30%;
    text-align: center;
    margin-top: 6px;
}

.pain-improvement-des {
    display: inline-block;
    color: #667480;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding: 10px 20px;
}

.text-container {
    height: 30%;
    text-align: center;
    margin-top: 6px;
}

.footer-container {
    margin: 15px;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 10px;
}

.footer-green-line {
    width: 100%;
    height: 6px;
    background: linear-gradient(90deg, #6DDA6C 14.2%, rgba(109, 218, 108, 0.00) 100%);
}

.download-pdf-button {
    width: 100%;
    background-color: #FF835B;
    color: white;
    padding: 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer
}

.average-pain-text {
    display: inline-block;
    color: #667480;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding: 0px 20px;
    padding-top: 10px;
}

.average-pain-small-text {
    display: inline-block;
    color: #667480;
    font-size: 8px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    width: 135px;
}`, "",{"version":3,"sources":["webpack://./src/components/pdf-generator/pdf-generator.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,WAAW;IACX,yDAAqE;IACrE,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,iFAAiF;AACrF;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iFAAiF;AACrF;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".pdf-container {}\n\n.top-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    height: 100%;\n    width: 100%;\n    padding: 1rem;\n    /* 16px padding on all sides */\n}\n\n.progress-report {\n    font-size: 23.672px;\n    color: white;\n    margin: 0px;\n    font-weight: 700;\n    margin-top: 4px;\n}\n\n.formatted-date {\n    color: rgba(255, 255, 255, 0.6);\n    font-size: 16px;\n    margin-top: 0px;\n    font-weight: 600px;\n    margin-top: 4px;\n}\n\n.overallimpact-section {\n    margin-left: 15px;\n    /* Equivalent to inline style */\n    margin-top: 24px;\n    /* Equivalent to mt-6 */\n    display: flex;\n    /* Equivalent to flex */\n    gap: 8px;\n    /* Equivalent to gap-[8px] */\n    color: #263238;\n}\n\n.overallimpact-section h3 {\n    font-size: 14px;\n    /* Equivalent to text-sm */\n    font-weight: 600;\n    /* Equivalent to font-semibold */\n    color: #263238;\n    margin: 0px;\n    margin-top: 6px;\n}\n\n.bg-img-container {\n    position: relative;\n    background-size: cover;\n    background-position: center;\n    height: 283px;\n    width: 100%;\n    background-image: url(\"/public/assets/images/pdfReportTopbanner.png\");\n    background-repeat: no-repeat;\n}\n\n.hz-line {\n    height: 6px;\n    background: linear-gradient(90deg, #6DDA6C 14.2%, rgba(109, 218, 108, 0.00) 100%);\n}\n\n.overall-impact-content {\n    background-color: #F6F5F5;\n    margin-left: 15px;\n    margin-right: 15px;\n    border-radius: 6px;\n    padding: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 12px;\n}\n\n.overall-impact-column {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n}\n\n.overall-impact-row {\n    display: flex;\n    align-items: start;\n    margin-bottom: 12px;\n}\n\n.overall-impact-row-1 {\n    display: flex;\n    flex-direction: column;\n    margin-right: 12px;\n}\n\n.percentage-text {\n    color: #FF835B;\n    font-size: 24px;\n    font-weight: 900;\n    line-height: 140%;\n    width: 85px;\n    text-align: right;\n    margin-top: 30px;\n    font-style: normal;\n}\n\n.vertical-divider {\n    border: 0.5px solid black;\n    height: 100px;\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.impact-description {\n    width: 245px;\n    display: flex;\n    flex-direction: column;\n}\n\n.impact-text {\n    color: #667480;\n    font-size: 12px;\n    font-style: normal;\n    line-height: normal;\n    margin-top: 12px;\n}\n\n.bold-text {\n    font-weight: bold;\n    margin: 0 4px;\n    color: black;\n}\n\n.small-text {\n    font-weight: bold;\n    margin: 0 2px;\n    font-size: 8px;\n}\n\n.big-vertical-divider {\n    margin-left: 30px;\n    margin-right: 10px;\n    height: 185px;\n    border: 1px solid #D1D5DB;\n}\n\n.standing-svg {\n    width: 46px;\n    height: 86px;\n    margin-bottom: 12px;\n}\n\n.total-exercise-count {\n    color: #222B45;\n    /* font-family: \"Sans-serif\", */\n    font-size: 24px;\n    font-style: normal;\n    font-weight: bold;\n    line-height: 140%;\n    text-align: center\n}\n\n.pain-improvement-section {\n    margin-left: 15px;\n    margin-top: 18px;\n    display: flex;\n    justify-content: start;\n    gap: 8px;\n}\n\n.pain-improvement-text {\n    font-size: 14px;\n    font-weight: 600;\n    color: #263238;\n    margin: 0px;\n    margin-top: 6px;\n}\n\n.pain-improvement-container {\n    margin-left: 15px;\n    margin-right: 15px;\n    margin-top: 12px;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 15px;\n}\n\n.pain-improvement-card {\n    height: 60mm;\n    max-width: 70mm;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: #e5e7eb;\n    padding: 9px;\n    border-radius: 6px;\n    height: 195px;\n}\n\n.circular-indicator-container {\n    height: 70%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.pain-improvement-text-con {\n    height: 30%;\n    text-align: center;\n    margin-top: 6px;\n}\n\n.pain-improvement-des {\n    display: inline-block;\n    color: #667480;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    padding: 10px 20px;\n}\n\n.text-container {\n    height: 30%;\n    text-align: center;\n    margin-top: 6px;\n}\n\n.footer-container {\n    margin: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    gap: 10px;\n}\n\n.footer-green-line {\n    width: 100%;\n    height: 6px;\n    background: linear-gradient(90deg, #6DDA6C 14.2%, rgba(109, 218, 108, 0.00) 100%);\n}\n\n.download-pdf-button {\n    width: 100%;\n    background-color: #FF835B;\n    color: white;\n    padding: 10px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer\n}\n\n.average-pain-text {\n    display: inline-block;\n    color: #667480;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    padding: 0px 20px;\n    padding-top: 10px;\n}\n\n.average-pain-small-text {\n    display: inline-block;\n    color: #667480;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    width: 135px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
